import { render, staticRenderFns } from "./InsuranceRefundNavigation.vue?vue&type=template&id=013e2e91&scoped=true&"
import script from "./InsuranceRefundNavigation.vue?vue&type=script&lang=js&"
export * from "./InsuranceRefundNavigation.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRefundNavigation.vue?vue&type=style&index=0&id=013e2e91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e2e91",
  null
  
)

export default component.exports